import { render, staticRenderFns } from "./PageTab.vue?vue&type=template&id=c6be2f3e&functional=true&"
import script from "./PageTab.vue?vue&type=script&lang=js&"
export * from "./PageTab.vue?vue&type=script&lang=js&"
import style0 from "./PageTab.vue?vue&type=style&index=0&id=c6be2f3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports